import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  tabsContainer: {
    marginTop: '20px',
  },
}))
